import { useState } from 'react';

interface AccordionProps {
  items: { question: string; answer: string }[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => setOpenIndex(openIndex === idx ? null : idx);

  return (
    <div className="space-y-3">
      {items.map((item, idx) => (
        <div key={idx} className="border border-background-200/70 rounded-lg overflow-hidden">
          <button
            onClick={() => toggle(idx)}
            className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">{item.question}</span>
            <i
              className={`ri-arrow-down-s-line text-lg text-foreground-600 transition-transform duration-200 flex-shrink-0 ${
                openIndex === idx ? 'rotate-180' : ''
              }`}
            ></i>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}